import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BillAccountContent } from "../../BillAccountContent";

export const AccountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Bill, any>) => (
        <ViewTableCell>
            <BillAccountContent bill={row.original} />
        </ViewTableCell>
    ),
);
